import { config } from 'util/config';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ componentDefaultValue });

  sectionComponent.child.map((child, i) => {
    if (child.current != null) {
      child.current?.setState({ searchParameter: { moduleId: parameter }, moduleId: parameter });
      child.current?.child.current?.setState({ moduleId: parameter });
      setTimeout(() => {
        child.current?.getSectionDataByDefault();
      }, config.setTimeoutMilliSecond);
    }
  })
}

// 点击新增
export function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'JobApprovedDocTemplate') {
      child.current?.setState({ showModal: true, componentType: 'Create' });
    }
  })
}
